// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var OAuthClientDetailsController = function ($scope, $rootScope, $routeParams, $location, OAuthClient, OAuthClientSecret, gettextCatalog, gettext) {

    $scope.popupSecretText = gettext("Copy and securely store the secret in your system — you won't be able to see it later.");
    $scope.isClientLoading = true;
    $scope.newClientSecret = new OAuthClientSecret();
    $scope.newRouteTemplate = "";
    
    $scope.webMethods = ["", "GET", "POST", "PUT", "DELETE"];
    $scope.selectedWebMethod = $scope.webMethods[0];

    $scope.client = {"Permissions": {"IsAdmin": false, "AllowedEndpoints": []}}; // default value to use on loading

    $scope.back = function back() {
        $location.path("/settings/oauth-clients");
    }

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form))
            return;
        
        $scope.client.$update({}, $scope.back);
    };

    var _txt = function (msg) {
        return gettextCatalog.getString(msg);
    };

    // Init
    var updatePage = function() {
        OAuthClient.get({clientId: $routeParams.id})
            .$promise
                .then((result) => {
                    $scope.client = result;

                    if(!$scope.client.Permissions) {
                        $scope.client.Permissions = {};
                        $scope.client.Permissions.IsAdmin = false;
                    }

                    if(!$scope.client.Permissions.AllowedEndpoints) {
                        $scope.client.Permissions.AllowedEndpoints = [];
                    }

                    $scope.isClientLoading = false;
                }).catch(() => {
                    $scope.isClientLoading = false;
                    $scope.back();
                });

    };
    updatePage();

    $scope.deleteSecret = function (secret) {
        $scope.yesCancel(_txt(gettext("Secret deletion")), _txt(gettext('Do you really want to revoke this secret. All active sessions created with that secret will end immediately!')),
            function() { 
                OAuthClient.deleteSecret(secret.Id)
                .then(() =>{
                    $scope.isClientLoading = true;
                    updatePage();
                })
                .catch(() => {})
             }
        );
    };

    $scope.createSecret = function () {
        if (!$rootScope.isValid($scope.form))
            return;

        $scope.newClientSecret.$create({clientId: $routeParams.id})
            .then((response) => {
                $scope.savedClientSecret = response;
                $scope.newClientSecret.Name = "";
                updatePage();
            });
    };

    $scope.isSecretSavingProhibited = function() {
        return $scope.newClientSecret && $scope.newClientSecret.Name && $scope.newClientSecret.Name.length > 0;
    };

    $scope.areRoutesVisible = function() {
        return !$scope.client.Permissions.IsAdmin && !$scope.isDataLoading();
    }

    $scope.areSecretsShown = function() {
        if(!$scope.client || !$scope.client.Secrets)
            return false;

        return $scope.client.Secrets.length > 0 && !$scope.isDataLoading();
    }

    $scope.isDataLoading = function() {
        return $scope.isClientLoading ;
    }

    $scope.isInfoboxShown = function() {
        if(!$scope.client || !$scope.client.Secrets)
            return false;

        return !$scope.isDataLoading() && $scope.client.Secrets.length === 0;
    }

    $scope.arePermissionsDefined = function() {
        return $scope.client.Permissions && $scope.client.Permissions.AllowedEndpoints;
    }

    $scope.deletePermission = function(index) {
        $scope.client.Permissions.AllowedEndpoints.splice(index, 1);
    };

    $scope.addPermission = function() {

        if($scope.selectedWebMethod !== "" && $scope.newRouteTemplate !== "") {
            $scope.client.Permissions.AllowedEndpoints.push(
                {
                    "HttpMethod": $scope.selectedWebMethod, 
                    "RouteTemplate": $scope.newRouteTemplate
                });
            $scope.newRouteTemplate = "";
            $scope.selectedWebMethod = $scope.webMethods[0];
        }
    }

    $scope.isAddingDisabled = function() {
        return $scope.selectedWebMethod === "" || $scope.newRouteTemplate === "";
    }

    $scope.onAllRoutesClick = function() {
        $scope.client.Permissions.IsAdmin = !$scope.client.Permissions.IsAdmin;
    }
};
OAuthClientDetailsController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', 'OAuthClient', 'OAuthClientSecret', 'gettextCatalog', 'gettext',];
